import {useContext} from 'react'
import { DocumentTrayContext } from '../DocumentTrayContexts'
import { KTIcon } from '../../../../../_metronic/helpers'


const PreviewDocumentModalHeader = () => {
  const {closePreviewDocumentModal, setFromPreviewTab} = useContext(DocumentTrayContext)

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Previsualizar Documento</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() =>{
          closePreviewDocumentModal()
          setFromPreviewTab({
            showSignature: false,
            signCeo: false,
            idUserSign: ''
          })
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {PreviewDocumentModalHeader}
